// If you want to use generator, please do not change this file manually and let generator take care of that
import Shopify from './Shopify';

// EXPORTS
export default {
    Shopify
};
